export const getCustomLocationFacetFaqs = (
  locationFaqs = [],
  termFaqs = [],
  term
) => {
  const locationFaqsWithTerm = locationFaqs.filter(
    (faq) => faq?.term?.title === term
  )
  const locationsFaqsWithoutTerm = locationFaqs.filter(
    (faq) => !faq?.term?.title
  )

  return [...locationFaqsWithTerm, ...termFaqs, ...locationsFaqsWithoutTerm]
}
